import type { SortDescriptor } from '@skupreme/shared/ui';
import type { ISortObject } from '../legacy-bridge';

/* Units are read most-first; names start A→Z. */
const FIRST_DIRECTION: Record<string, 'asc' | 'desc'> = {
  name: 'asc',
  total_items: 'desc',
};

export function toSortDescriptor(
  sort: ISortObject | undefined,
): SortDescriptor | undefined {
  /* An unset column reads as `''`, e.g. the inventory's `{ title: '' }`. */
  const [column, direction] =
    Object.entries(sort ?? {}).find(([, value]) => !!value) ?? [];

  if (!column) {
    return undefined;
  }

  return {
    column,
    direction: direction === 'desc' ? 'descending' : 'ascending',
  };
}

/*
 * React Aria opens every newly picked column ascending; a column with its own
 * first direction starts there instead, then toggles as usual.
 */
export function fromSortDescriptor(
  descriptor: SortDescriptor,
  current: ISortObject | undefined,
  firstDirection: Record<string, 'asc' | 'desc'> = FIRST_DIRECTION,
): ISortObject {
  const column = String(descriptor.column);

  if (!current?.[column]) {
    return { [column]: firstDirection[column] ?? 'asc' };
  }

  return { [column]: descriptor.direction === 'descending' ? 'desc' : 'asc' };
}
